/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useState } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import s from './style/Dropdown.module.scss';
import { setTempLocation, resetTags } from '../../Slice/impactReportSlice';
import type { RootState } from '../../../../store/store';

export interface IDropdownData {
  locationType: number;
  value: string;
}

const Dropdown: FC = () => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState<boolean>(false);
  const items = useAppSelector((state) => state.impactReport);

  return (
    <div className={s.dropdown}>
      <div className={s.dropdown__btn} onClick={() => setIsActive(!isActive)}>
        {items.tempLocation.value
          ? items.tempLocation.value
          : 'Select Location Type'}
        <span className={`${s.dropdown__btn__icon} fa fa-chevron-down`} />
      </div>
      {isActive && (
        <ClickAwayListener onClickAway={() => setIsActive(false)}>
          <div className={s.dropdown__content}>
            {items.allFilters.map((item: any) => (
              <div
                onClick={() => {
                  dispatch(setTempLocation(item));
                  dispatch(resetTags());
                  setIsActive(false);
                }}
                className={s.dropdown__content__item}
                key={item.value}
              >
                {item.value}
              </div>
            ))}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default Dropdown;
